import React from "react";

const ServerIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="16"
      width="16"
      viewBox="0 0 48 48"
      fill="none"
      className={className}
    >
      <title>stack</title>
      <g
        strokeLinejoin="miter"
        fill="#212121"
        strokeLinecap="butt"
        className="nc-icon-wrapper"
      >
        <polyline
          data-color="color-2"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="square"
          strokeMiterlimit="10"
          points=" 41,22.2 44,24 24,36 4,24 7.333,22 "
        ></polyline>{" "}
        <polyline
          data-color="color-2"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="square"
          strokeMiterlimit="10"
          points=" 40.67,32.002 44,34 24,46 4,34 7.333,32 "
        ></polyline>{" "}
        <polygon
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="square"
          strokeMiterlimit="10"
          points="4,14 24,2 44,14 24,26 "
        ></polygon>
      </g>
      <defs>
        <clipPath id="clip0_5331_716">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ServerIcon;
